import { Brand } from '@promoboxx/graphql-gateway-types'
import { useSelector } from 'react-redux'

import {
  brandsForCurrentRetailerAccountSelector,
  currentBrandSelector,
} from '../../stores/app/selectors'

export const useAssetTags = () => {
  const brands: Brand[] = useSelector(brandsForCurrentRetailerAccountSelector)
  const currentBrand: Brand | null = useSelector(currentBrandSelector)
  if (currentBrand) {
    return currentBrand.digital_asset_tags || []
  }

  const combinedTags = brands
    .map((brand: Brand) => brand.digital_asset_tags || [])
    .reduce((a, b) => [...a, ...b], [])

  return Array.from(new Set(combinedTags))
}
